<template>
  <g transform="translate(-1)">
    <g>
      <g>
        <path
          d="M128.686,37.216c-4.761-4.067-11.789-4.012-16.486,0.128L77.853,68.081v-4.028c0-4.713-3.82-8.533-8.533-8.533
        s-8.533,3.82-8.533,8.533v19.311L46.561,96.096c-3.459,3.155-3.73,8.508-0.607,11.997s8.473,3.809,11.99,0.718l62.575-56.013
        l62.575,56.013c2.266,2.067,5.468,2.759,8.385,1.812c2.918-0.947,5.102-3.387,5.722-6.392c0.62-3.004-0.42-6.11-2.724-8.135
        L128.686,37.216z"/>
        <path
          d="M171.72,119.52c-4.713,0-8.533,3.82-8.533,8.533v59.733H77.853v-59.733c0-4.713-3.82-8.533-8.533-8.533
        s-8.533,3.82-8.533,8.533v65.152c0.084,6.515,5.432,11.729,11.947,11.648h95.573c6.519,0.066,11.862-5.155,11.947-11.674v-65.126
        C180.253,123.34,176.432,119.52,171.72,119.52z"/>
        <path
          d="M120.52,221.92c-32.99,0-59.733,26.744-59.733,59.733s26.744,59.733,59.733,59.733s59.733-26.744,59.733-59.733
        C180.215,248.679,153.494,221.957,120.52,221.92z M77.853,281.653c0.026-20.268,14.281-37.731,34.133-41.813v36.975
        L80.413,295.75C78.76,291.232,77.894,286.464,77.853,281.653z M89.207,310.382l29.99-17.994l24.815,24.815
        C126.579,328.833,103.257,325.93,89.207,310.382z M156.078,305.137l-27.025-27.017V239.84
        c13.892,2.815,25.474,12.357,30.895,25.454C165.368,278.391,163.918,293.327,156.078,305.137z"/>
        <path
          d="M461.853,153.653v-29.21c-0.005-7.43-6.027-13.452-13.457-13.457H424.11c-7.43,0.005-13.452,6.027-13.457,13.457v29.21
        h-17.067v-53.504c-0.009-8.149-6.613-14.753-14.763-14.763h-21.675C349,85.396,342.396,92,342.386,100.149v53.504H325.32V59.786
        c0-9.426-7.641-17.067-17.067-17.067h-17.067c-9.426,0-17.067,7.641-17.067,17.067v93.867h-8.533
        c-4.713,0-8.533-3.821-8.533-8.533V42.72c0-4.713-3.821-8.533-8.533-8.533s-8.533,3.82-8.533,8.533v102.4
        c0,14.138,11.461,25.6,25.6,25.6h196.267c4.713,0,8.533-3.82,8.533-8.533S466.566,153.653,461.853,153.653z M308.253,153.653
        h-17.067V59.786h17.067V153.653z M376.52,153.653h-17.067v-51.2h17.067V153.653z M444.786,153.653H427.72v-25.6h17.067V153.653z"
        />
        <path
          d="M461.853,324.32H265.586c-4.713,0-8.533-3.82-8.533-8.533v-13.534l28.1-28.1c3.371-3.236,8.695-3.236,12.066,0
        l10.001,10.001c9.997,9.994,26.202,9.994,36.198,0l35.601-35.601c3.371-3.236,8.695-3.236,12.066,0l10.001,10.01
        c10.008,9.966,26.19,9.966,36.198,0l30.601-30.601c3.234-3.348,3.188-8.671-0.104-11.962c-3.292-3.292-8.614-3.338-11.962-0.104
        l-30.601,30.592c-3.332,3.331-8.734,3.331-12.066,0l-10.001-10.001c-10.13-9.668-26.069-9.668-36.198,0l-35.601,35.601
        c-3.332,3.331-8.734,3.331-12.066,0l-9.992-10.001c-10.132-9.669-26.075-9.669-36.207,0l-16.034,16.034v-64.734
        c0-4.713-3.821-8.533-8.533-8.533s-8.533,3.821-8.533,8.533v102.4c0,14.138,11.461,25.6,25.6,25.6h196.267
        c4.713,0,8.533-3.821,8.533-8.533C470.386,328.14,466.566,324.32,461.853,324.32z"/>
        <path
          d="M513.053,396.46V47.37c1.187-24.814-17.863-45.94-42.667-47.317H43.72C18.916,1.431-0.134,22.557,1.053,47.37v349.09
        c-1.191,24.817,17.859,45.948,42.667,47.326h136.533v17.067H146.12c-18.851,0-34.133,15.282-34.133,34.133v8.533
        c0,4.713,3.82,8.533,8.533,8.533h273.067c4.713,0,8.533-3.82,8.533-8.533v-8.533c0-18.851-15.282-34.133-34.133-34.133h-34.133
        v-17.067h136.533C495.194,442.409,514.244,421.277,513.053,396.46z M367.986,477.92c9.426,0,17.067,7.641,17.067,17.067h-256
        c0-9.426,7.641-17.067,17.067-17.067H367.986z M197.32,460.853v-17.067h119.467v17.067H197.32z M470.386,426.72H43.72
        c-15.361-1.41-26.754-14.877-25.6-30.259V375.52h477.867v20.941C497.141,411.843,485.748,425.31,470.386,426.72z M495.986,47.37
        v311.083H18.12V47.37c-1.154-15.381,10.24-28.845,25.6-30.251h426.667C485.746,18.525,497.141,31.989,495.986,47.37z"/>
      </g>
    </g>
  </g>
</template>

<script>
    export default {
        /*props: {
          viewBox: {
            type: String,
            default: '0 -18 511.99961 511'
          },
        },*/
        data() {
            return {
                viewBox: '0 -18 511.99961 511'
            }
        }
    }
</script>
